import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { DungeonBuilder } from "@/src/components/DungeonBuilder";
import "@/src/globals.css";

const container = document.getElementById("root");
if (!container) throw new Error("Missing #root element in index.html");

createRoot(container).render(
  <StrictMode>
    <DungeonBuilder />
  </StrictMode>,
);
